module.exports = __webpack_public_path__ + "0900f662be3b5a8ea3c6277ac2cc01cf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/legend.png
// module id = i2PN
// module chunks = 0